import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs.2.12.313.worker.js';

/**
 * Mitigation for CVE-2024-4367 (GHSA-wgrm-67xf-hhpq) — arbitrary JS execution in pdf.js.
 *
 * In pdfjs-dist < 4.2.67 a crafted PDF can run arbitrary JavaScript in the application
 * origin through the font glyph compilation path (`/FontMatrix` -> `new Function`).
 * Setting `isEvalSupported: false` closes the eval/glyph path (the gate sits in
 * `FontFaceObject.getPathGenerator` before `new Function(...)`).
 *
 * This constant MUST be passed to every place where the app loads a PDF document
 * (`<Document options={...} />`, `pdfjs.getDocument({ ... })`) — do not inline the flag
 * locally, otherwise new viewers silently lose the mitigation.
 */
export const PDFJS_SECURITY_OPTIONS = {
    isEvalSupported: false,
};
